import React from 'react';
import {
    Datagrid,
    List,
    TextField,
    EditButton,
    DeleteButton,
    ShowButton,
    ReferenceField,
    DateField,
} from 'react-admin';

const UserServiceTransaction = (props: any) => {
    return (
        <List {...props}>
            <Datagrid>
                <TextField source='id' />
                <ReferenceField label="User Service bundle Mapping" source="userServiceBundleMappingId" reference="UserBundleServiceMapping">
                    <TextField source="id"/>
                </ReferenceField>
                <TextField source="state" />
                <DateField source="date"/>
                <TextField source="time" />
                <TextField source="userId" />
                <TextField source="userType" />
                <TextField source="commentFromUser" />
                <TextField source="commentFromAdmin" />
                <DeleteButton/>
                <EditButton/>
                <ShowButton/>
            </Datagrid>
        </List>
    );
};

export default UserServiceTransaction;